



















































































import {
  defineComponent,
  ref,
  Ref,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import { useGetters } from "vuex-composition-helpers";
import axios from "axios";
import useFetcher from "@use/useFetcher";
import CurrentTags from "@c/molecules/current/CurrentTags.vue";
import CurrentNotes from "@c/molecules/current/CurrentNotes.vue";
import PlaceModel from "@/ts/models/placeClass";
import ProjectModel from "@/ts/models/projectClass";
import EventModel from "@/ts/models/eventClass";
import NetSlide from "@c/organisms/app/NetSlide.vue";
import PlaceHeader from "@c/organisms/place/PlaceHeader.vue";
import CreateButton from "@c/atoms/app/CreateButton.vue";
import description from '@/vue/components/molecules/text/description.vue';

export default defineComponent({
  name: "PlaceOverview",

  props: {
    place: Object as () => PlaceModel,
    loading_place: Boolean
  },

  components: {
    CurrentTags,
    CurrentNotes,
    NetSlide,
    PlaceHeader,
    CreateButton,
    description
  },

  setup(props, { root }) {

    const place_id = parseInt(root.$route.params.id);


    onMounted(() => {
      window.scrollTo(0, 0);
    });

    var { entity: projects, loading: loading_projects } = useFetcher(
      "project/GET_PROJECTS_BY_PLACE",
      {action_param:place_id}
    );
    var { entity: events, loading: loading_events } = useFetcher(
      "event/GET_EVENTS_BY_PLACE",
      {action_param:place_id}
    );
    var { entity: notes, loading: loading_notes } = useFetcher(
      "note/GET_NOTES_BY_PLACE",
      {action_param:place_id}
    );

    var pastProjects:any = computed(() => {     
      return root.$options.filters!.past(projects.value)
    })

    var pastEvents:any = computed(() => {     
      return root.$options.filters!.past(events.value)
    })

    return {
      loading_projects,
      loading_events,
      loading_notes,
      projects,
      events,
      notes,
      pastProjects,
      pastEvents
    };
  }
});
